import { getAuthAxiosBackend } from "../../helpers/axios"

class MartyrServices{

    get(id){
        return getAuthAxiosBackend().get('government-loans/martyrs/'+id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('government-loans/martyrs', {params: data})
    }

    delete(id){
        return getAuthAxiosBackend().delete('government-loans/martyrs/' + id)
    }
}

export default new MartyrServices()